import { SelectionModel } from '@angular/cdk/collections';
import { NestedTreeControl } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import '@app/common/array-extensions';
import { SimplifiedTerm } from '@app/models/simplified-term';

@Component({
  selector: 'app-channel-control',
  templateUrl: './channel-control.component.html',
  styleUrls: ['./channel-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChannelControlComponent implements OnInit {
  nestedTreeControl: NestedTreeControl<SimplifiedTerm>;
  nestedDataSource: MatTreeNestedDataSource<SimplifiedTerm>;
  checklistSelection = new SelectionModel<SimplifiedTerm>(true);
  @Output() selectionChange = new EventEmitter<SimplifiedTerm[]>();
  @Input() channels: Array<SimplifiedTerm>;
  hasChannelSelected = false;

  constructor() {
    this.nestedTreeControl = new NestedTreeControl<SimplifiedTerm>(this._getChildren);
    this.nestedDataSource = new MatTreeNestedDataSource();
  }

  todoLeafItemSelectionToggle(node: SimplifiedTerm): void {
    this.checklistSelection.toggle(node);
    const selectedChannels = this.channels.filterRecursive(c => c.Selected, 'Terms');
    selectedChannels.length > 1
    ? this.hasChannelSelected = true
    : this.hasChannelSelected = false;

  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: SimplifiedTerm): void {
    this.checklistSelection.toggle(node);

    const descendants = this.nestedTreeControl.getDescendants(node) // remove depricated and non tagable child nodes from auto selection.
      .filter(cn => {
        if (cn.IsDeprecated || !cn.IsAvailableForTagging) {
          return false;
        } else { return true; }
      });

    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );

    const selectedChannels = this.channels.filterRecursive(c => c.Selected, 'Terms');
    selectedChannels.length > 1
    ? this.hasChannelSelected = true
    : this.hasChannelSelected = false;
  }

  hasNestedChild = (_: number, node: SimplifiedTerm) => node?.Terms?.length > 0;

  private _getChildren = (node: SimplifiedTerm) => node.Terms;

  ngOnInit() {
    if (this.channels) {
      this.nestedDataSource.data = this.channels;

      const selectedChannels = this.channels.filterRecursive(c => c.Selected, 'Terms');

      if (selectedChannels.length > 0) {
        this.checklistSelection.select(...selectedChannels);
      }

      selectedChannels.length > 1
      ? this.hasChannelSelected = true
      : this.hasChannelSelected = false;
     }
    this.checklistSelection.changed.subscribe(change => {
        change.added.forEach(c => c.Selected = true);
        change.removed.forEach(c => c.Selected = false);
        this.selectionChange.emit(this.checklistSelection.selected);
      });

  }

  clear() {

    const allTerms = this.channels.filterRecursive(c => c, 'Terms');

    this.nestedTreeControl.dataNodes = allTerms;
    for (let i = 0; i < this.nestedTreeControl.dataNodes.length; i++) {
      if (this.checklistSelection.isSelected(this.nestedTreeControl.dataNodes[i])) {
        this.checklistSelection.toggle(this.nestedTreeControl.dataNodes[i]);
      }
    }
    this.hasChannelSelected = false;
  }
}

@NgModule({
  declarations: [ChannelControlComponent],
  exports: [ChannelControlComponent],
  imports: [
    CommonModule,
    MatTreeModule,
    MatButtonModule,
    MatCheckboxModule,
  ]
})
export class ChannelControlModule { }
